
var KOSTORAGE = function(ko, store) {
//store is amplify storage wrapper library
    
    var globalStorageProviderIndexStore = {};

    function getNextStorageProviderIndex(vmKey, options) {

        if (options && options.create) globalStorageProviderIndexStore[vmKey] = -1;

        return globalStorageProviderIndexStore[vmKey] += 1;

    }

    ko.extenders.storageProvider = function (target, provider) {

        // var storageProviderIndex = 'Prop' + getNextStorageProviderIndex(provider.vmKey);
        var storageProviderIndex = '';
        if(provider.propertyName)
        {
            storageProviderIndex = provider.propertyName;
        }
        else
        {
            storageProviderIndex = 'Prop' + getNextStorageProviderIndex(provider.vmKey);
        }

        var existing = store(provider.vmKey) || {};

        var value = existing[storageProviderIndex] || target();

        target(value);

        target.subscribe(function(newValue) {

            var collection = store(provider.vmKey) || {};
            collection[storageProviderIndex] = newValue;
            store(provider.vmKey, collection, { expires: provider.storageExpiry });
        });

        //Clear propertyName for next extenders - so it will default.
        provider.propertyName = '';

        return target;
    }

    ko.storage = {

        createStorageProvider: function(viewModelIdentifier, galleryKey, storageExpiry) {

            var vmKey = galleryKey + '.' + viewModelIdentifier;

            getNextStorageProviderIndex(vmKey, { create: true });

            var provider = {
                storageProvider: { vmKey: vmKey, storageExpiry: storageExpiry || null },
                setPropertyName: function (propertyName) {
                    this.storageProvider["propertyName"] = propertyName;
                    return this;
                },
                //additional method to add named values that aren't via extended observables.
                store: function (namedKey, newValue) {
                    var collection = store(vmKey) || {};                   
                    if (newValue === undefined) return collection[namedKey];
                    collection[namedKey] = newValue;
                    return store(vmKey, collection, { expires: storageExpiry });                    
                }
            }

            return provider;
        },

        ViewModel : function(storageProvider, properties) {

            var self = this;
            properties.foreach(function(i, property) { self[property] = ko.observable().extend(storageProvider) });
        },

        clear: function(viewModelIdentifier, galleryKey){

            var vmKey = galleryKey + '.' + viewModelIdentifier;
            store(vmKey, null);
            return true;
        }

    }
    return ko.storage;

}

module.exports = KOSTORAGE;
